import React, { Component } from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';
import InputMask from 'react-input-mask';
import emailjs from 'emailjs-com';

import styles from './FormRegistration.scss';
import { Select } from './Select';
import Button from '../../common/Button/Button';
import tracker from '../../../services/tracker';
import { withTranslation } from 'react-i18next';
import i18n from '../../../i18n';

const emailReg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const workOptions = [
  i18n.t('components.login.formRegistration.workOptions1'),
  i18n.t('components.login.formRegistration.workOptions2'),
  i18n.t('components.login.formRegistration.workOptions3')
];

class FormRegistration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: '',
      isButtonDisabled: true,
      name: '',
      nameError: false,
      surName: '',
      surNameError: false,
      currentWork: '',
      currentWorkError: false,
      phoneNumber: props.phone || '',
      phoneNumberError: false,
      email: '',
      emailError: false,
      city: '',
      cityError: false
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleButtonClick = this.handleButtonClick.bind(this);
  }

  handleInputChange({ target }) {
    const { value } = target;
    const { key } = target.dataset;
    this.setState({ [key]: value });
  }

  handleButtonClick(e) {
    const { name, surName, phoneNumber, email, currentWork, city } = this.state;
    const nameError = /[^A-Za-zа-яА-ЯёЁ]+/.test(name);
    const surNameError = /[^A-Za-zа-яА-ЯёЁ]+/.test(surName);
    const emailError = !emailReg.test(email.toLowerCase());
    const phoneNumberError = phoneNumber.length < 16;
    const currentWorkError = currentWork.length === 0;
    const cityError = city.length === 0;
    const isError = cityError || nameError || surNameError || emailError || phoneNumberError || currentWorkError;

    e.preventDefault();
    if (isError) {
      this.setState({ cityError, nameError, surNameError, phoneNumberError, emailError, currentWorkError });
    } else {
      tracker.sendEvent('Web_User_Registration');
      this.sendEmail({ name, surName, phoneNumber, email, currentWork, city });
    }
  }

  sendEmail(userInfo) {
    this.setState({ isLoading: true });
    emailjs.send('service_zymp8wm', 'template_6il5vuh', userInfo, 'user_htj8iGWJNHzX84IftFgix')
      .then(() => {
        this.props.handleRegistrationSuccessfully();
      }, error => {
        this.props.handleRegistrationError(error);
      });
  }

  render() {
    const { handleCloseModal, t } = this.props;

    const {
      isLoading,
      name,
      nameError,
      surName,
      surNameError,
      currentWork,
      currentWorkError,
      phoneNumber,
      phoneNumberError,
      email,
      emailError,
      city,
      cityError
    } = this.state;

    const isButtonDisabled = !city || name.length === 0 || surName.length === 0 || phoneNumber.length === 0 || email.length === 0;

    return (
      <div className={styles.Overlay}>
        <div className={styles.Modal}>
          <div className={styles.CloseButton} onClick={handleCloseModal} />
          <span className={styles.Title}>
            {t('components.login.formRegistration.title')}
          </span>
          <form role="form">
            <div className={cn(styles.Input, nameError && styles.InputError)}>
              <label htmlFor="name">{nameError ? t('components.login.formRegistration.nameError') : ''}</label>
              <InputMask
                id="name"
                data-key="name"
                value={name}
                placeholder={t('components.login.formRegistration.name')}
                onChange={this.handleInputChange}
              />
            </div>
            <div className={cn(styles.Input, surNameError && styles.InputError)}>
              <label htmlFor="surName">{surNameError ? t('components.login.formRegistration.surNameError') : ''}</label>
              <InputMask
                id="surName"
                value={surName}
                data-key="surName"
                placeholder={t('components.login.formRegistration.surName')}
                onChange={this.handleInputChange}
              />
            </div>
            <span className={styles.WorkTypeSpan}>
              {t('components.login.formRegistration.currentWork')}
            </span>
            <label htmlFor="currentWork">{currentWorkError ? t('components.login.formRegistration.currentWorkError') : ''}</label>
            <Select
              style={{ marginBottom: '5px' }}
              id="currentWork"
              data-key="currentWork"
              isError={currentWorkError}
              placeholder="—"
              value={currentWork}
              options={workOptions}
              onChange={value => this.setState({ currentWork: value })}
            />
            <span className={styles.WorkTypeSpan}>
              {t('components.login.formRegistration.city')}
            </span>
            <label htmlFor="currentWork">{cityError ? t('components.login.formRegistration.cityError') : ''}</label>
            <Select
              style={{ marginBottom: '5px' }}
              id="city"
              data-key="city"
              isError={cityError}
              placeholder="—"
              value={city}
              options={this.props.cities}
              onChange={value => this.setState({ city: value })}
            />
            <div className={cn(styles.Input, phoneNumberError && styles.InputError)}>
              <label htmlFor="FormNumber-phone">{phoneNumberError ? t('components.login.formRegistration.phoneNumberError') : ''}</label>
              <InputMask
                type="tel"
                id="FormNumber-phone"
                data-key="phoneNumber"
                value={phoneNumber}
                placeholder="+7 (999) 999 99 99"
                onChange={this.handleInputChange}
                mask="+7 999 999 99 99"
                maskChar=""
              />
            </div>
            <div className={cn(styles.Input, emailError && styles.InputError)}>
              <label htmlFor="email">{emailError ? t('components.login.formRegistration.emailError') : ''}</label>
              <InputMask
                type="email"
                id="email"
                data-key="email"
                value={email}
                placeholder={t('components.login.formRegistration.email')}
                onChange={this.handleInputChange}
                mask=""
                maskChar=""
              />
            </div>
            {isLoading ? (
              <div className={styles.Wrapper}>
                <div className={styles.Loader} />
              </div>
            ) : (
              <Button
                type="submit"
                className={styles.SubmitButton}
                disabled={isLoading || isButtonDisabled}
                onClick={this.handleButtonClick}
              >

                {t('components.login.formRegistration.send')}
              </Button>
            )}
          </form>
          <span
            className={styles.Politician}
            dangerouslySetInnerHTML={{ __html: t('components.login.formRegistration.politician') }}
          />
        </div>
      </div>
    );
  }
}

export default connect((state) => ({ cities: state.building.cities.map(({ name }) => name) }))(withTranslation()(FormRegistration));



// WEBPACK FOOTER //
// ./src/components/Login/FormRegistration/FormRegistration.js